module.exports = __webpack_public_path__ + "static/media/iap-split-pink.3f3174eb.png";